import { Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { CONSTANTS } from 'src/app/constants';
import { ApiService } from 'src/app/shared/service/api.service';

@Component({
  selector: 'app-financial-ranking-clients',
  templateUrl: './financial-ranking-clients.component.html',
  styleUrls: ['./financial-ranking-clients.component.css']
})
export class FinancialRankingClientsComponent implements OnInit {
  
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }
  @Output() errorEmitter = new EventEmitter();

  dataSource: any = {
    chart: {
      numberPrefix: "R$ ",
      theme: "fusion",
      paletteColors: "#5D62B4",
      maxBarHeight: "14",
      showValues: "1",
      placeValuesInside: "0"
    },
    data: []
  }

  selectItem: any = [
    { label: 'Maior valor em atraso', value: 1 },
    { label: 'Maior valor', value: 2 },
  ]
  itemSelected: any = 1;

  branchSelected: any;
  objFilter: any;
  
  loading: boolean = true;
  errorApi: boolean = false;
  message : string = "";

  constructor(private api: ApiService) { }

  ngOnInit(): void {
  }

  changeEventSelect(item: any) {
    this.loading = true;
    if (item == 1) {
      this.itemSelected = 1;
      //this.rankingClientsDebtorsInformation(this.branchSelected)
      this.rankingClientsDebtorsInformation(this.objFilter)
    } else {
      this.itemSelected = 2;
      //this.rankingClientsBiggestInformation(this.branchSelected)
      this.rankingClientsBiggestInformation(this.objFilter)
    }
  }

  filterItem(item: any) {
    this.errorApi = false;
    this.loading = true;
    this.objFilter = item;
    this.changeEventSelect(1);
  }

  rankingClientsDebtorsInformation(item: any) {
    this.errorApi = true;
    this.api.postCustomerTopDebtors(item.branch).subscribe(data => {
      try {
        this.dataSource.data = [];
        this.dataSource.chart.paletteColors = '#F1726F';
        if(data.dataRow.length != 0)
        {
          data.dataRow.map((el:any) => {
            this.dataSource.data.push({
              'label': el.customer_name,
              'value': el.customer_value,
              'valueBgColor': '#F9F9F9'
            })
          })
          this.errorApi = false;
          this.loading = false;
        } else {
          this.loading = false;
          this.message = CONSTANTS.MESSAGES.DATA_NULL_RANKING_CUSTOMER_TOP_DEPTORS;
          this.formatErrorMensagem(CONSTANTS.MESSAGES.DATA_NULL_RANKING_CUSTOMER_TOP_DEPTORS);
        }
      } catch (error : unknown) {
        this.loading = false;
        if (error instanceof Error)
          this.message = error.message;
          this.formatErrorMensagem(this.message);
      }
    }, error => {
      this.loading = false;
      this.message = CONSTANTS.MESSAGES.DATA_ERRO_RANKING_CUSTOMER_TOP_DEPTORS;
      this.formatErrorMensagem(error.message);
    });
  }

  rankingClientsBiggestInformation(item: any) {
    this.errorApi = true;
    this.api.postCustomerTopBiggest(item.dataMin, item.dataMax, item.branch).subscribe(data => {
      try {
        this.dataSource.data = [];
        this.dataSource.chart.paletteColors = '#5D62B4';
        if(data.dataRow.length != 0)
        {
          data.dataRow.map((el:any) => {
            this.dataSource.data.push({
              'label': el.customer_name,
              'value': el.customer_value,
              'valueBgColor': '#F9F9F9'
            })
          })
          this.errorApi = false;
          this.loading = false;
        } else {
          this.loading = false;
          this.message = CONSTANTS.MESSAGES.DATA_NULL_RANKING_CUSTOMER_TOP_BIGGERS;
          this.formatErrorMensagem(CONSTANTS.MESSAGES.DATA_NULL_RANKING_CUSTOMER_TOP_BIGGERS);
        }
      } catch (error : unknown) {
        this.loading = false;
        if(error instanceof Error)
          this.message = error.message;
          this.formatErrorMensagem(this.message);
      }
    }, error => {
      this.loading = false;
      this.message = CONSTANTS.MESSAGES.DATA_ERRO_RANKING_CUSTOMER_TOP_BIGGERS;
      this.formatErrorMensagem(error.message);
    })
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: financial-ranking-clients \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }
}
